exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".upload-field-box__content{background-color:var(--wf-secondary);border:1px solid #bfbfbf;padding:10px;border-radius:10px}", ""]);

// exports
